import script from "./AddQuestionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQuestionPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddQuestionPage.vue?vue&type=style&index=0&id=0ef4cdef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef4cdef"]])

export default __exports__